<template>
  <v-app>
    <LoadingWidget v-if="loading" />

    <template v-else>
      <HeaderShell />
      <NavigationWidget />

      <v-main>
        <BannerWidget v-if="smAndDown" type="carousel" category="Full Banner" />

        <router-view v-bind="$route.meta" />
      </v-main>

      <FooterShell />
    </template>

    <CookieBannerWidget />
    <GalleryWidget />
    <WhatsAppButtonWidget
      v-if="informations.whatsapp"
      :tel="informations.whatsapp"
    />
  </v-app>
</template>

<script>
import HeaderShell from "./components/shell/HeaderShell/Index.vue";
import FooterShell from "./components/shell/FooterShell.vue";
import CookieBannerWidget from "./components/widgets/CookieBannerWidget.vue";
import LoadingWidget from "./components/widgets/LoadingWidget.vue";
import GalleryWidget from "./components/widgets/GalleryWidget.vue";
import NavigationWidget from "./components/widgets/NavigationWidget.vue";
import WhatsAppButtonWidget from "./components/widgets/WhatsAppButtonWidget.vue";
import BannerWidget from "./components/widgets/BannerWidget.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    updateDocumentTitle() {
      if (this.name && this.$route.name) {
        document.title = `${this.$route.name} | ${this.name}`;
      } else if (this.name && !this.$route.name) {
        document.title = this.name;
      } else if (!this.name && this.$route.name) {
        document.title = this.$route.name;
      } else {
        document.title = "";
      }
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
  },
  created() {
    this.updateDocumentTitle();

    const gettedInformations = this.$rest("informations").get({
      save: (state, data) => (state.item = data),
    });

    const gettedEventsCategories = this.$rest("events-categories").get();

    Promise.all([gettedInformations, gettedEventsCategories]).finally(
      () => (this.loading = false)
    );
  },
  components: {
    HeaderShell,
    FooterShell,
    CookieBannerWidget,
    LoadingWidget,
    GalleryWidget,
    NavigationWidget,
    WhatsAppButtonWidget,
    BannerWidget,
  },
};
</script>
